<template>
  <div id="order-list">
    <vs-tabs :color="colorx" style="background: #fff">
      <vs-tab @click="selectTab('active')" label="Active orders">
        <order-order-list @openDetailModal="openDetailModal" @pageChanged="changePageActive" :currentPage="active_current_page" :itemsPerPage="itemsPerPage" :key="active_key" @ChangeToFirstPage="changePageActive(1)"></order-order-list>
      </vs-tab>
      <vs-tab @click="selectTab('completed')" label="Completed orders">
        <order-order-list @openDetailModal="openDetailModal" @pageChanged="changePageComplete" :currentPage="complete_current_page" :itemsPerPage="itemsPerPage" :key="complete_key"></order-order-list>
      </vs-tab>
    </vs-tabs>
    <order-order-detail :config="config" :key="detail_key" :currentPage="active_current_page" :itemsPerPage="itemsPerPage" @ChangeToFirstPage="changePageActive(1)"></order-order-detail>
  </div>
</template>

<script>
import OrderList from "../../components/order/OrderList";
import OrderDetail from "../../components/order/OrderDetail";
import { EventSourcePolyfill } from "event-source-polyfill";
import { domain, client_id } from "../../axios";
import * as md5 from "md5";

export default {
  props: {
    dataChange: {
      type: Object
    }
  },
  components: {
    "order-order-list": OrderList,
    "order-order-detail": OrderDetail
  },
  created() {
    this.subscribeTopic();
    let obj = {
      page: this.active_current_page,
      'per-page': this.itemsPerPage
    }
    this.$store.dispatch("order/ORDER_LIST", obj);
    const lastRecord = () => {
      this.$store.dispatch("order/CHECK_UPDATE").then(data => {
        if(data && data.id != null && data.id != undefined) {
          let lastOrderRecord = JSON.parse(localStorage.getItem('lastOrderRecord'));
          // if(lastOrderRecord == null) {
          //   localStorage.setItem('lastOrderRecord', JSON.stringify({ id: data.id, updated_at: data.updated_at }));
          // } else {
            if(lastOrderRecord && (lastOrderRecord.id != data.id || lastOrderRecord.updated_at != data.updated_at)) {
              this.$store.dispatch("order/ORDER_LIST", { page: this.active_current_page, 'per-page': this.itemsPerPage });
            }
            localStorage.setItem('lastOrderRecord', JSON.stringify({ id: data.id, updated_at: data.updated_at }));
          // }
        }
      });
    };
    lastRecord();
    this.interval = setInterval(lastRecord, 5000);
  },
  destroyed() {
    clearInterval(this.interval);
    this.eventSource.close();
  },
  methods: {
    openDetailModal(order) {
      this.config.isActive = true;
      this.config.orderId = order.id;
      this.detail_key++;
    },
    selectTab(status) {
      this.colorx = "primary";
      if (status == "active") {
        this.active_orders = true;
        let obj = {
          page: 1,
          'per-page': this.itemsPerPage
        }
        this.$store.dispatch("order/ORDER_LIST", obj).then(() => {
          this.active_current_page = 1;
        });
      } else if (status == "completed") {
        this.active_orders = false;
        let obj = {
          page: 1,
          'per-page': this.itemsPerPage,
          order_status: 6
        }
        this.$store.dispatch("order/ORDER_LIST", obj).then(() => {
          this.complete_current_page = 1;
        });
      }
    },
    changePageActive(page) {
      let obj = {
        page: page,
        'per-page': this.itemsPerPage
      }
      this.$store.dispatch("order/ORDER_LIST", obj).then(() => {
        this.active_current_page = page;
        this.active_key++;
      })
    },
    changePageComplete(page) {
      let obj = {
        page: page,
        'per-page': this.itemsPerPage,
        order_status: 6
      }
      this.$store.dispatch("order/ORDER_LIST", obj).then(() => {
        this.complete_current_page = page;
        this.complete_key++;
      })
    },
    getDomain() {
      let temp = domain;
      if (domain[domain.length - 1] == "/") {
        temp = domain.slice(0, -1);
      }
      return temp.substring(temp.lastIndexOf("/") + 1);
    },
    subscribeTopic() {
      let topic = "/v1/orderonline/order";
      let hubUrl = "";
      let jwt = "";
      if (process.env.NODE_ENV == "development") {
        hubUrl = process.env.VUE_APP_DEVELOPMENT_MERCURE_HUB_URL;
        jwt = process.env.VUE_APP_DEVELOPMENT_MERCURE_JWT;
      } else {
        let mercure = JSON.parse(localStorage.getItem("appMercure"));
        hubUrl = mercure.hub_url;
        jwt = mercure.jwt;
      }
      const option = {
        headers: {
          Authorization: "Bearer " + jwt
        }
      };
      let id = md5(client_id);
      const u = new URL(hubUrl);
      u.searchParams.append("topic", id + "/" + this.getDomain() + topic);
      this.eventSource = new EventSourcePolyfill(u, option);
      this.eventSource.onmessage = e => {
        this.dataChange.message = JSON.parse(e.data);
        this.dataChange.key++;
        // console.log(this.dataChange)
      };
    }
  },
  data() {
    return {
      colorx: "primary",
      config: {
        isActive: false,
        orderId: 1
      },
      detail_key: 0,
      active_orders: true,
      active_current_page: 1,
      complete_current_page: 1,
      itemsPerPage: 10,
      active_key: 0,
      complete_key: 0,
      interval: null
    };
  },
  watch: {
    dataChange: {
      immediate: true,
      deep: true,
      handler: function() {
        if (this.dataChange.message != "") {
          if (this.active_orders == true) {
            let obj = {
              page: this.active_current_page,
              'per-page': this.itemsPerPage
            }
            this.$store.dispatch("order/ORDER_LIST", obj);
          } else if (this.active_orders == false) {
            let obj = {
              page: this.complete_current_page,
              'per-page': this.itemsPerPage,
              order_status: 6
            }
            this.$store.dispatch("order/ORDER_LIST", obj);
          }
        }
      }
    }
  }
};
</script>